import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Card, CardBody, CustomInput } from "reactstrap";
import PersonalWebsiteAddAgents from "./PersonalWebsiteAddAgents";
import { errorHandler } from "../../../../helper-methods";
import {
  getAgentWebsiteDetail,
  updateAgentWebsiteDetail,
} from "../../../../http/http-calls";

const PersonalWebsiteSetp3 = ({ manageLoadingState }, ref) => {
  // Define a state variable to store the input value

  const [agentWebsiteDetails, setAgentWebsiteDetails] = useState({});
  const [selectedValue, setSelectedValue] = useState("ClosewiseverifiedNna");
  const [isFormDirty, setIsFormDirty] = useState(false);

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
    setIsFormDirty(true);
  };

  const _onSubmit = async () => {
    if (isFormDirty) {
      try {
        manageLoadingState("stepLoading", true);
        const payload = {
          showJobForwardingSelectedAgents:
            selectedValue === "InvitesAgentsOnly" ? true : false,
        };
        await updateAgentWebsiteDetail(payload);
        manageLoadingState("stepLoading", false);
      } catch (err) {
        errorHandler(err);
        console.log(err);
        manageLoadingState("stepLoading", false);
      }
    }
  };

  useImperativeHandle(ref, () => ({
    _onSubmit,
    isWebsiteLaunched: agentWebsiteDetails?.isWebsiteLaunched,
  }));

  const _getAgentWebsite = async () => {
    try {
      const res = await getAgentWebsiteDetail();
      console.log({ res });
      setAgentWebsiteDetails(res?.agentWebsite);

      const newSelectedValue =
        res?.agentWebsite?.showJobForwardingSelectedAgents === true
          ? "InvitesAgentsOnly"
          : "ClosewiseverifiedNna";

      setSelectedValue(newSelectedValue);
    } catch (err) {
      console.log({ err });
      errorHandler(err);
    }
  };

  useEffect(() => {
    _getAgentWebsite();
  }, []);

  return (
    <>
      <Card>
        <CardBody>
          <div className="d-flex align-items-center justify-content-center flex-wrap mt-4 mb-4">
            <CustomInput
              value="ClosewiseverifiedNna"
              type="radio"
              id="exampleCustomRadio"
              name="customRadio"
              label="Closewise verified or NNA verified Agents"
              checked={selectedValue === "ClosewiseverifiedNna"}
              onChange={handleRadioChange}
              inline
            />
            <CustomInput
              value="InvitesAgentsOnly"
              type="radio"
              id="exampleCustomRadio1"
              name="customRadio"
              label="Invites Only"
              checked={selectedValue === "InvitesAgentsOnly"}
              onChange={handleRadioChange}
              inline
            />
          </div>
          {selectedValue === "InvitesAgentsOnly" ? (
            <PersonalWebsiteAddAgents />
          ) : null}
        </CardBody>
      </Card>
    </>
  );
};

export default forwardRef(PersonalWebsiteSetp3);
